import { WifiOff } from "lucide-react";

import { useOfflineStatus } from "@/hooks/useOfflineStatus";

/** Fixed banner shown while offline. Reassures the user their data is intact. */
export function OfflineBanner(): JSX.Element | null {
  const offline = useOfflineStatus();
  if (!offline) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 bg-amber-500/15 px-4 py-1.5 text-center text-sm text-amber-900 backdrop-blur dark:text-amber-200"
    >
      <WifiOff className="h-4 w-4" />
      You&apos;re offline. All your data is still accessible.
    </div>
  );
}
